import { SynDropdown } from "./chunk.DMPOPGWM.js";

// src/components/dropdown/dropdown.ts
var dropdown_default = SynDropdown;
SynDropdown.define("syn-dropdown");
export { dropdown_default };
